import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import UserService from '../../../services/user.service'

function VerifyAccount() {
    const params = useParams()
    const navigate = useNavigate()
    const verifyAccount = async () => {
        const res: any = await UserService.verifyAccount(params?.token as string)
        if (res?.msg) {
            localStorage.setItem("msg", res.msg)
            navigate("/login")
        }
    }
    useEffect(() => {
        if (params?.token) {
            verifyAccount()
        }
    }, [params?.token])
    return null
}

export default VerifyAccount